import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation deleteQrCodeMutation($input: DeleteQrCodeInput!) {
    deleteQrCode(input: $input) {
      destroyedQrCodeId
      lists {
        ...QrCodeList_lists
      }
    }
  }
`;

const deleteQrCode = (environment, qrCodeId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: qrCodeId,
      },
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'QrCodeList_qrCodes' }],
        pathToConnection: ['lists', 'qrCodes'],
        deletedIDFieldName: 'destroyedQrCodeId',
      },
    ],
    ...args,
  });
};

export default deleteQrCode;
